interface Props {
  filled: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: number;
  title?: string;
}

export function StarButton({ filled, onClick, size = 20, title }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title ?? (filled ? 'Remove from favourites' : 'Add to favourites')}
      aria-label={title ?? (filled ? 'Remove from favourites' : 'Add to favourites')}
      aria-pressed={filled}
      className={`shrink-0 inline-flex items-center justify-center rounded-md p-1 transition ${
        filled
          ? 'text-amber-500 hover:text-amber-600'
          : 'text-slate-300 dark:text-slate-600 hover:text-slate-500 dark:hover:text-slate-400'
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </button>
  );
}
